import { render, staticRenderFns } from "./QuestionSetScore.vue?vue&type=template&id=63b982a2&scoped=true"
import script from "./QuestionSetScore.ts?vue&type=script&lang=ts&external"
export * from "./QuestionSetScore.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionSetScore.vue?vue&type=style&index=0&id=63b982a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b982a2",
  null
  
)

export default component.exports